import ENV from "@/costants/constants"

// Event object
const EventItem = {
  "id": 0,
  "account": ENV.ACCOUNT_ID,
  "event": {
    "id": ENV.EVENT_ID,
    "nm": ENV.EVENT_ID_NAME
  },
  "events": {
    "ids": ENV.EVENTS_IDS_ITEM,
    "nms": [
      {
        "id": ENV.EVENT_ID,
        "nm": ENV.EVENT_ID_NAME
      }
    ]
  },
  "time": {
    "vl": "1970-01-01T00:00:00+00",
    "vle": "1970-01-01T00:00:00+00"
  },
  "locality": {
    "id": ENV.LOCALITY_ID,
    "dtl": {
        "vl": "",
        "gps": "",
        "region": ""
    }
  },
  "countries": {
    "ids": ENV.COUNTRIES_IDS_ITEM,
    "nms": [
      {
        "id": ENV.LOCALITY_ID,
        "nm": ENV.LOCALITY_ID_NAME
      }
    ]
  },
  "clsfrs": {
    "ids": ENV.EVENT_CLS,
    "nms": [
        {
          "id": ENV.EVENT_CLS_ID,  
          "nm": "HI-BI Information Themes Сlassifier"
        }
    ]
  },
  "vid": 217,
  "tp": 0,
  "vl": -7777777,
  "svl": "",
  "igrp": true,
  "icln": true,
  "inw": true,
  "ich": false,
  "isDlt": false,
  "msrs": [
    {
      "vid": 226,
      "nm": "HI-BI General Values Event name",
      "lbl": "HI-BI General Values Event name",
      "tp": 1,
      "vl": -7777777,
      "svl": "",
      "icln": false,
      "inw": true,
      "ich": false,
      "isDlt": false
    },
    {
      "vid": 229,
      "nm": "HI-BI General Values Is Important",
      "lbl": "HI-BI General Values Is Important",
      "tp": -1,
      "vl": 0,
      "svl": "",
      "inw": true,
      "ich": false,
      "icln": false,
      "isDlt": false
    },
    {
      "vid": 227,
      "nm": "HI-BI General Values Event short HTML",
      "lbl": "HI-BI General Values Event short HTML",
      "tp": 64,
      "vl": -7777777,
      "svl": "",
      "icln": false,
      "inw": true,
      "ich": false,
      "isDlt": false
    },
    {
      "vid": 228,
      "nm": "HI-BI General Values Event HTML",
      "lbl": "HI-BI General Values Event HTML",
      "tp": 64,
      "vl": -7777777,
      "svl": "",
      "icln": false,
      "inw": true,
      "ich": false,
      "isDlt": false
    },
    {
      "vid": 222,
      "nm": "HI-BI General Values Link Items",
      "lbl": "",
      "tp": 4,
      "vl": -7777777,
      "svl": "",
      "icln": true,
      "inw": true,
      "ich": false,
      "isDlt": false,
      "clctn": []
    },
    {
      "vid": 223,
      "nm": "HI-BI General Values File Items",
      "lbl": "",
      "tp": 8,
      "vl": -7777777,
      "svl": "",
      "icln": true,
      "inw": true,
      "ich": false,
      "isDlt": false,
      "clctn": []
    },
  ]
}

export default EventItem
